function digital(v) {
    const h = Math.floor(v);
    const m = Math.round((v - h) * 60);
    return `${h < 10 ? '0' : ''}${h}:${m < 10 ? '0' : ''}${m}`;
}
export default {
    digital
};
